module.exports = __webpack_public_path__ + "assets/img/pinanLogo.d642c09b.png";